import { WizardFlow } from '~/graphql/types.client';
import { id as stepId, title } from '../../GenericSteps/GenericStep';
import { ExtendedAppConfig } from '~/hooks/useApps';

/**
 * Returns default wizard flow for provided app
 * @param {ExtendedAppConfig} app
 * keywords: wizard flow, default wizard
 */

const getGenericWizardFlow = (app: ExtendedAppConfig): WizardFlow => {
  const id = app.__typename;

  const enablementFlow: WizardFlow = {
    id,
    steps: [
      { title: title, id: stepId, metadata: { typename: app.__typename } },
    ],
  };

  return enablementFlow;
};
export default getGenericWizardFlow;
